import { useMutation } from '@apollo/client';

import { UpdateCompanyLogoInput } from '__generated__/GQL';
import useCompanyContext from 'common/hooks/useCompanyContext';

import { UpdateCompanyLogoDocument } from './graphql/updateCompanyLogo.gql';

export const useUpdateCompanyLogoMutation = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is undefined in useUpdateCompanyLogoMutation',
    );
  }

  const [mutation, hook] = useMutation(UpdateCompanyLogoDocument);

  const updateCompanyLogo = ({
    logoBucketName,
    logoFileRef,
  }: Pick<UpdateCompanyLogoInput, 'logoBucketName' | 'logoFileRef'>) =>
    mutation({
      variables: {
        input: {
          companyProfileId,
          logoBucketName,
          logoFileRef,
        },
      },
    });

  return [updateCompanyLogo, hook] as const;
};
